import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import terminology from 'javascripts/terminology';
import AhaBaseEventListener from 'components/common/AhaBaseEventListener';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';

const RecordTypePicker = () => {
  const controller = useController(CardLayoutEditorController);
  const { currentRecordLayoutKey } = controller;
  const { availableRecordLayouts, cardLayout } = controller.state;

  if (availableRecordLayouts.length < 2) return null;

  return (
    <aha-tabs>
      <aha-tab-list style={{ paddingLeft: 18 }}>
        {availableRecordLayouts.map((recordLayoutKey, index) => {
          const recordLayout = cardLayout[recordLayoutKey];
          const { modelClass } = recordLayout;

          return (
            <AhaBaseEventListener
              Component='aha-tab'
              key={recordLayoutKey}
              eventListeners={{
                tabChosen: () => {
                  controller.actionSetRecordLayout(recordLayoutKey);
                },
              }}
              selected={recordLayoutKey === currentRecordLayoutKey || null}
            >
              {terminology(modelClass.terminologyName, { isPlural: true })}
            </AhaBaseEventListener>
          );
        })}
      </aha-tab-list>
    </aha-tabs>
  );
};

export default view(RecordTypePicker);
